<router-outlet></router-outlet>
<app-locale-menu *ngIf="!isLogged" [isLogged]="isLogged"></app-locale-menu>
<app-footer class="footer dark:bg-gray-800"></app-footer>
